module.exports = {
  getEmptyCustomer: (isCompany = false) => {
    return {
      first_name: '',
      middle_name: '',
      last_name: '',
      company_name: '',
      personal_id: '',
      is_company: isCompany,
      email: '',
      phone: '',
      status: '',
      title: '',
      email2: '',
      phone1: '',
      phone2: '',
      acquisition_source: '',
      acquisition_source_text: '',
      tax_status_uuid: '',
      tags: [],
      commissions: [],
      billingAddresses: [],
      shippingAddresses: [],
      addresses: [],
      bank_accounts: [],
      logo_uuid: null,
      skip_auction_deposit_requirement: false,
    }
  },
  getEmptyAddress: () => {
    return {
      address_1: '',
      address_2: '',
      city: '',
      state: '',
      zip_code: '',
      country_code: '',
      type: '',
    }
  },
  getEmptyBankAccount: (customerUuid = null) => {
    return {
      customer_uuid: customerUuid,
      account_name: '',
      account_number: '',
      sort_code: '',
      bank_name: '',
      swift: '',
      is_primary: false,
    }
  },
  getEmptyIdentification: () => {
    return {
      personal_identification_number: null,
      document_type: null,
      document_number: null,
      document_issue_date: null,
      document_expiry_date: null,
      date_of_birth: null,
      citizenship_code: null,
      residency_code: null,
      country_of_birth_code: null,
      place_of_issue: null,
    }
  },
};
